import { IconButton, IconButtonProps } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

import { useMessageCenterContext } from 'modules/IMC/MessageCenter/context';

export default function ClearSearchGoBack(props: IconButtonProps) {
    const { setSearchQuery, searchQuery } = useMessageCenterContext();

    if (!searchQuery) {
        return null;
    }

    const handleClick = () => {
        setSearchQuery('');
    };

    return (
        <IconButton aria-label="Go back" onClick={handleClick} sx={{ padding: 0 }} {...props}>
            <ArrowBack />
        </IconButton>
    );
}
